// 请求安全校验的check_key值
export const CHECK_KEY = '87435979f891460c19s8d2f22f389345'



// WEBPACK FOOTER //
// ./src/config.js